import { io } from "socket.io-client";
import API_BASE_URL from "../config/env";

let socket = null;

export const connectSocket = () => {
  if (socket) return socket;

  const token = localStorage.getItem("token");

  if (!token) {
    console.warn("No token found. Socket not connected.");
    return null;
  }

  socket = io(API_BASE_URL, {
    transports: ["websocket"], // force WS
    forceNew: true, // no SID reuse
    auth: {
      token,
    },
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
  });

  socket.on("connect", () => {
    //console.log("Socket connected:", socket.id);
  });

  socket.on("disconnect", (reason) => {
    console.log("Socket disconnected:", reason);
  });

  socket.on("connect_error", (err) => {
    console.error("Socket connect error:", err.message);
  });

  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
